export default "__VITE_PUBLIC_ASSET__8e947fed__"